<template>
  <div
    class="tab-bar fixed fb fb-main-between fb-cross-center bg-FFFFFF width-full"
  >
    <a
      class="block item-flex-1"
      v-for="(item, index) in tabBarList"
      :key="index"
      @click="() => goPage(item)"
    >
      <div class="text-center c-171A1D-40">
        <div
          ><i
            class="iconfont font-48"
            :class="{ curPage: curIndex === index }"
            v-html="curIndex === index ? item.checkIcon : item.defaultIcon"
          ></i
        ></div>
        <p
          :class="{
            'c-006AFE': curIndex === index
          }"
          >{{ item.buttonName }}</p
        >
      </div>
    </a>
  </div>
</template>

<script>
import { mcOpenLink } from '@/utils/mcSdkUtils'
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    tabBarList() {
      return this.$store.getters.routeForTabbar
    },
    curIndex() {
      const curIndex = this.tabBarList.findIndex(item => {
        // 比较原始路由，去掉/full或者/gray前缀
        if (
          this.$route.path.startsWith('/full') ||
          this.$route.path.startsWith('/gray')
        ) {
          const path = this.$route.path.substring(5)
          return path === item.route.path
        }
        return item.route.path === this.$route.path
      })
      return curIndex
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    goPage(routeConfig) {
      const linkType = routeConfig.linkType || 0 // 0: 站内 1: 站外 2: 事件
      switch (`${linkType}`) {
        case '0':
          this.$router.replace({ ...routeConfig.route })
          break
        case '1':
          mcOpenLink({ url: routeConfig.route.path })
          break
        case '2':
          routeConfig.callback(routeConfig.route.query)
          break
        case '3':
          this.$router.push({
            path: '/banner-iframe',
            query: {
              url: routeConfig.route.path
            }
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-bar {
  bottom: 0;
  height: 62px !important;
  box-shadow: 0px -0.5px 0px 0px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(20px);
}
.curPage {
  background-image: -webkit-linear-gradient(top, #00b7ff, #006afe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
